import React from 'react';
import { cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

const linkClasses = cva(
  'inline-flex items-center transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-1 hover:opacity-80',
  {
    variants: {
      variant: {
        primary: 'text-red-600 hover:text-red-700 focus:ring-red-500',
        secondary: 'text-gray-600 hover:text-gray-700 focus:ring-gray-500',
        underline: 'underline hover:no-underline',
        button: 'px-4 py-2 rounded-md bg-red-600 text-white hover:bg-red-700',
      },
      size: {
        small: 'text-sm',
        medium: 'text-base',
        large: 'text-lg',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'medium',
    },
  }
);

const Link = ({
  // Standard props
  href = '#',
  children,
  variant,
  size,
  className,
  target,
  rel,
  onClick,
  'aria-label': ariaLabel,
  ...props
}) => {
  const handleClick = (event) => {
    if (typeof onClick === 'function') {
      onClick(event);
    }
  };

  // Determine if it's an external link
  const isExternal = href?.startsWith('http') || href?.startsWith('//');
  const linkRel = rel || (isExternal ? 'noopener noreferrer' : undefined);
  const linkTarget = target || (isExternal ? '_blank' : undefined);

  return (
    <a
      href={href}
      target={linkTarget}
      rel={linkRel}
      onClick={handleClick}
      aria-label={ariaLabel}
      className={twMerge(linkClasses({ variant, size }), className)}
      {...props}
    >
      {children}
    </a>
  );
};

export default Link;